import {Modal} from "@ui";
import {useTranslation} from "react-i18next";

const AccountValidation = ({error, onClose}) => {
  const {t} = useTranslation();

  const getErrorMessage = () => {
    if (!error?.message) {
      return t("registrationValidationModalError");
    }

    const errorMessage = error.message;

    if (errorMessage.includes("email") || errorMessage.includes("Email")) {
      return t("registrationValidationModalEmail");
    }

    if (errorMessage.includes("phone") || errorMessage.includes("Phone")) {
      return t("registrationValidationModalPhone");
    }

    if (errorMessage.includes("national_id") || errorMessage.includes("ID")) {
      return t("registrationValidationModalId");
    }

    return t("registrationValidationModalError");
  };

  const handleClose = () => {
    if (onClose) {
      onClose();
    }
  };

  return (
    <Modal
      title={t("registrationAccountValidationModal")}
      open={!!error}
      onOk={handleClose}
      onCancel={handleClose}
      okText="OK"
      cancelButtonProps={{style: {display: "none"}}}
      centered
    >
      <p>{getErrorMessage()}</p>
    </Modal>
  );
};

export default AccountValidation;
